import './mask/index';
import SmoothScroll from './scroll/SmoothScroll';
import Theme from './theme';

new SmoothScroll().init();
new Theme().init();
